/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

//import { Spin } from 'antd';
import {
  //useSelector,
  useDispatch,
} from 'react-redux';
//import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';

import { convertDataFromReduxToServer } from './tools';
import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
//import Preview from './Preview';
import TopConfigs from './TopConfigs';
import FeatureProducts from './FeatureProducts';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import CloneBtn from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/CloneButton';

import {
  request_get404Page,
  request_submit,
  getState,
  getHasModified,
  //getContentSetting,
  //getFeatureProduct,
  getSalesChannelContent,
  getSalesChannelName,
  // getLoading,
  // getButtonText,
  resetAll,
  validation,
  getLoaded,
} from './slice';

import styles from './style.module.less';
import { useParams } from 'react-router-dom';
import { IParams } from '../common';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';

// interface IParams {
//   contentUuid: string;
//   saleChannelUuid: string;
// }

function SalesChangeEditor404Page(props) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
    loaded,
    currentStyle,
    currentSize,
  } = props;

  const _d = useDispatch();
  // const contentSetting = useSelector(getContentSetting());
  // const featureProducts = useSelector(getFeatureProduct());
  // const buttonText = useSelector(getButtonText());
  //const loading = useSelector(getLoading());

  const _params: IParams = useParams();

  const { contentUuid } = _params;

  React.useEffect(() => {
    return () => {
      _d(resetAll());
    };
  }, []);

  const ele = React.useMemo(() => {
    switch (currentStyle) {
      case WebSiteSubType.NativeMobile: {
        if (isOnPrimaryLanguage) {
          return [
            {
              body: (
                <TopConfigs
                  contentUuid={contentUuid}
                  isPrimary={isOnPrimaryLanguage}
                  currentStyle={currentStyle}
                  currentSize={currentSize}
                />
              ),
              key: 'TopSettingContent',
            },
            {
              body: (
                <FeatureProducts
                  currentSize={currentSize}
                  currentStyle={currentStyle}
                />
              ),
              key: 'FeatureProducts',
            },
          ];
        } else {
          return [
            {
              body: <CloneBtn />,
              key: 'CloneBtn',
            },
            {
              body: (
                <TopConfigs
                  contentUuid={contentUuid}
                  isPrimary={isOnPrimaryLanguage}
                  currentSize={currentSize}
                  currentStyle={currentStyle}
                />
              ),
              key: 'TopSettingContent',
            },
            { body: <FeatureProducts />, key: 'FeatureProducts' },
          ];
        }
      }
      case WebSiteSubType.ResponsivePage: {
        switch (currentSize) {
          case EPreviewSize.WIDE: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentStyle={currentStyle}
                      currentSize={currentSize}
                    />
                  ),
                  key: 'TopSettingContent',
                },
                {
                  body: (
                    <FeatureProducts
                      currentSize={currentSize}
                      currentStyle={currentStyle}
                    />
                  ),
                  key: 'FeatureProducts',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentSize={currentSize}
                      currentStyle={currentStyle}
                    />
                  ),
                  key: 'TopSettingContent',
                },
              ];
            }
          }
          case EPreviewSize.TABLET: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentStyle={currentStyle}
                      currentSize={currentSize}
                    />
                  ),
                  key: 'TopSettingContent',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentSize={currentSize}
                      currentStyle={currentStyle}
                    />
                  ),
                  key: 'TopSettingContent',
                },
              ];
            }
          }
          case EPreviewSize.MOBILE: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentStyle={currentStyle}
                      currentSize={currentSize}
                    />
                  ),
                  key: 'TopSettingContent',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <TopConfigs
                      contentUuid={contentUuid}
                      isPrimary={isOnPrimaryLanguage}
                      currentSize={currentSize}
                      currentStyle={currentStyle}
                    />
                  ),
                  key: 'TopSettingContent',
                },
              ];
            }
          }
        }
      }
    }
  }, [isOnPrimaryLanguage, currentSize, currentStyle]);

  return (
    <React.Fragment>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: true,
        }}
        leftChild={
          <PreviewStyleSwitch
            style={currentStyle}
            styleChild={
              <div
                style={{
                  height: 10000,
                  backgroundColor: 'transparent',
                  // margin: '0 auto',
                }}>
                123
              </div>
            }
            normalChild={
              <div className={styles.left}>
                {/* <Spin spinning={loading}> */}
                {/* {loaded ? (
                  <Preview
                    contentSetting={contentSetting}
                    buttonText={buttonText}
                    featureProducts={featureProducts}
                  />
                ) : null} */}

                {/* </Spin> */}
              </div>
            }
          />
        }
        rightChild={
          loaded ? (
            <RightConfigWrapper title={'404 Page'} elements={ele} />
          ) : null
        }
      />
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChangeEditor404Page, {
  siteStyleInParams: true,
  previewSizeInParams: true,
  getState,
  convertDataFromReduxToServer,
  submit: request_submit,
  getHasModified,
  getSalesChannel: getSalesChannelContent,
  getSalesChannelName: getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      request_get404Page({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
